import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { NavigationContext } from '@context/NavigationContext'
import { PredictionContext } from '@context/PredictionContext'
import { SurveyContext } from '@context/SurveyContext'
import { SurveyMode } from '@reducers/SurveyReducer'
import { SurveyStep } from '@models/Survey/SurveyStep'
import { TabbedPane } from '@components/Survey/TabbedPane/TabbedPane'
import { DsmpChart } from '@components/Survey/Dsmp/DsmpChart'
import { DefiDatagotchiCallout } from '@components/DefiDatagotchiCallout/DefiDatagotchiCallout'
import { usePreventBackNavigation } from '@hooks/usePreventBackNavigation'
import './DsmpResultPage.scss'

type Props = {
  variant: 'intermediate' | 'final'
}

export function DsmpResultPage({ variant }: Props) {
  usePreventBackNavigation()
  const { t } = useTranslation('DsmpResult')
  const { t: tResult } = useTranslation('Result')
  const { setPrevHandler, setNextHandler } = useContext(NavigationContext)
  const { dsmpQ1, dsmpQ2 } = useContext(PredictionContext)
  const { setMode, setNextStep, continueToSecondQuestionnaire } = useContext(SurveyContext)

  useEffect(() => {
    setMode(SurveyMode.RESULTS)
    setPrevHandler(undefined)
    if (variant === 'intermediate') {
      setNextHandler(() => {
        continueToSecondQuestionnaire().then(() => setNextStep(SurveyStep.Answer))
      })
    } else {
      setNextHandler(() => setNextStep(SurveyStep.Sandbox))
    }
    return () => {
      setMode(SurveyMode.DEFAULT)
      setNextHandler(undefined)
    }
  }, [variant])

  const tabs = [{ text: t('navigation.title') }]

  return (
    <TabbedPane
      tabs={tabs}
      contentText={variant === 'intermediate' ? t('intermediate.intro') : t('final.intro')}
      propClassName="DsmpResultPage">
      <DsmpChart dsmpQ1={dsmpQ1} dsmpQ2={variant === 'final' ? dsmpQ2 : undefined} />
      <DefiDatagotchiCallout className="DsmpResultPage-defi">
        <p>
          {variant === 'intermediate'
            ? t('intermediate.continueHint')
            : tResult('questionTextSimulator')}
        </p>
      </DefiDatagotchiCallout>
    </TabbedPane>
  )
}

export default DsmpResultPage
